import { isNullOrUndefined } from '@/utils/comparators'

const nbrOfMembershipMinutes = (state) => (amount) => {
  if (isNullOrUndefined(state) ||
    isNullOrUndefined(state.worldCredit) ||
    isNullOrUndefined(state.worldCredit.membershipRate)) {
    return 0
  }

  var lowest = state.worldCredit.membershipRate
  if (lowest === 0) {
    return 0
  }

  var minutes = Math.floor(parseFloat(amount / lowest))
  return minutes
}

const membershipRateFormatted = (state) => () => {
  if (isNullOrUndefined(state) ||
    isNullOrUndefined(state.worldCredit) ||
    isNullOrUndefined(state.worldCredit.membershipRateFormatted)) {
    return 0
  }

  var lowest = state.worldCredit.membershipRateFormatted
  return lowest
}

export default {
  nbrOfMembershipMinutes,
  membershipRateFormatted
}



// WEBPACK FOOTER //
// ./src/store/modules/rates/getters.js